import { ApiUser } from 'api/userEnvironment/types/ApiUserEnvironment';
import { getJson, postJson } from 'utils/http';

import { ApiInvite } from './types/ApiInvite';

export function apiFetchInvite(inviteId: string): Promise<ApiInvite> {
  return getJson(`/data/website/invites/${inviteId}`).then(
    // @ts-expect-error TS(2345): Argument of type '({ invite }: { invite: any; }) =... Remove this comment to see the full error message
    ({ invite }) => invite,
  );
}

export function apiAcceptInvite(inviteId: string): Promise<ApiUser> {
  // @ts-expect-error TS(2345): Argument of type '({ user }: { user: any; }) => an... Remove this comment to see the full error message
  return postJson(`/data/website/invites/${inviteId}`).then(({ user }) => user);
}
